export const MAIN_MAIL = 'angelo.scialpi@redwinglabs.com';
export const INFO_MAIL = 'info@redwinglabs.com';
